<!-- src/views/About.vue -->
<template>
    <div>
      <h1>About Page</h1>
      <!-- Your about page content goes here -->
    </div>
  </template>
  
  <script>
  export default {
    name: 'AboutPage',
  };
  </script>
  